import * as Sentry from "@sentry/nextjs";

type ErrorContext = Record<string, unknown>;

/**
 * Central error sink. Always logs to the console (so failures show up in
 * the hosting platform's logs) and forwards to Sentry. Kept as a thin
 * wrapper so call sites don't depend on the SDK directly.
 */
export async function reportError(
  error: unknown,
  context?: ErrorContext,
): Promise<void> {
  console.error("[studio.chat]", error, context ?? {});
  Sentry.captureException(error, context ? { extra: context } : undefined);
}
